import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Search from "./Actions/Search/Search";

const appendMemberProp = ({ mutatedMember,selectedMember, prop }) => {
    return  {
        ...mutatedMember,
        [prop]: [
            ...mutatedMember[prop],
            ...selectedMember[prop],
        ]
    }
}

const clearMemberProp = ({ mutatedMember, prop }) => {
    return  {
        ...mutatedMember,
        [prop]: []
    }
}

const getMemberWithCounterChanges = ({ member, assignedMembers, selectedMember}) => {
    let mutatedMember = {
        ...member,
        assigneeIn: member.assigneeIn || [],
        reviewerIn: member.reviewerIn || [],
        approverIn: member.approverIn || [],
    };
    const isCurrentMember = mutatedMember.id === selectedMember.id; 
    
    if (isCurrentMember) {
        if (assignedMembers.assignee) {
            mutatedMember = clearMemberProp({ mutatedMember, prop: 'assigneeIn' });
        }
        if (assignedMembers.reviewer) {
            mutatedMember = clearMemberProp({ mutatedMember, prop: 'reviewerIn' });
        }
        if (assignedMembers.approver) {
            mutatedMember = clearMemberProp({ mutatedMember, prop: 'approverIn' });
        }
    } else {
        if (member.id === assignedMembers.assignee) {
            mutatedMember= appendMemberProp ({ mutatedMember, selectedMember, prop: 'assigneeIn' })
        }
    
        if (member.id === assignedMembers.reviewer) {
            mutatedMember= appendMemberProp ({ mutatedMember, selectedMember, prop: 'reviewerIn' })
        }
    
        if (member.id === assignedMembers.approver) {
            mutatedMember= appendMemberProp ({ mutatedMember, selectedMember, prop: 'approverIn' })
        }
    }

    return mutatedMember;
}

@connect(store => {
    return {
        workstreams: store.workstreams,
    };
})

class ReassignTask extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: null,
            isClose: false,
            assignedMembers: {
                assignee: 0,
                approver: 0,
                reviewer: 0
            }
        }
    }

    render() {
        const { workstreams, dispatch, projectId } = this.props;

        const handleClose = () => {
            dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED_MEMBER", member: {} });

            this.setState({
                ...this.state, 
                isClose: true, 
                assignedMembers: {
                    assignee: 0,
                    approver: 0,
                    reviewer: 0
                }
            });

            $("#reassignTask").modal("hide");
        }

        const handlePrefilters = (type) => {
            dispatch({ type: "SET_TASKS_PREFILTERS", column: "workstream", filter: workstreams.selected.workstream });
            dispatch({ type: "SET_TASKS_PREFILTERS", column: type, filter: workstreams.selectedMember.id });
            window.open(`/account#/projects/${projectId}/processes/tasks?memberType=${type}&userId=${workstreams.selectedMember.id}&workstreamId=${encodeURIComponent(workstreams.selected.workstream)}`, '_blank');
        }

        const handleChangeAssignee = (value) => {
            this.setState({
                ...this.state, 
                assignedMembers: {
                    ...this.state.assignedMembers, 
                    assignee: value.value
                }
            })
        }

        const handleChangeApprover = (value) => {
            this.setState({
                ...this.state, 
                assignedMembers: {
                    ...this.state.assignedMembers, 
                    approver: value.value
                }
            })
        }

        const handleChangeReviewer = (value) => {
            this.setState({
                ...this.state, 
                assignedMembers: {
                    ...this.state.assignedMembers, 
                    reviewer: value.value
                }
            })
        }

        const handleSave = () => {
            const toUpdate =  workstreams.selected.toUpdate?workstreams.selected.toUpdate:[]
            const updatedMembers = {};
            let assignee={}, approver={}, reviewer={};

            for (const [, updatedMemberId] of Object.entries(this.state.assignedMembers)) {
                if (updatedMemberId > 0) {
                    updatedMembers[updatedMemberId] = updatedMemberId;
                }
            }

            dispatch({
                type: "UPDATE_WORKSTREAMS_SELECTED", 
                selected: {
                    ...workstreams.selected,
                    members: Object.keys(updatedMembers).length < 1
                        ? workstreams.selected.members
                        : workstreams.selected.members.map(m => {
                        let assigneeTasks = ((m.taskList || {}).assignee || []);
                        let reviewerTasks = ((m.taskList || {}).reviewer || []);
                        let approverTasks = ((m.taskList || {}).approver || []);

                        let currentMemmber = getMemberWithCounterChanges({
                            member: m,
                            assignedMembers: this.state.assignedMembers,
                            selectedMember: workstreams.selectedMember,
                        })

                        if (this.state.assignedMembers.assignee && this.state.assignedMembers.assignee === m.id) {
                            assigneeTasks = [...assigneeTasks, ...workstreams.selectedMember.assigneeIn];
                            assignee = {
                                users: {
                                    new: m.id,
                                    old: workstreams.selectedMember.id
                                },
                                taskIds: [...workstreams.selectedMember.assigneeIn]
                            }
                        } else if((this.state.assignedMembers.assignee === null && m.id === workstreams.selectedMember.id) || (this.state.assignedMembers.assignee !== 0 && this.state.assignedMembers.assignee !== workstreams.selectedMember.id && m.id === workstreams.selectedMember.id)) {
                           if(this.state.assignedMembers.assignee === null) {
                                assignee = {
                                    users: {
                                        new: null,
                                        old: workstreams.selectedMember.id
                                    },
                                    taskIds: [...workstreams.selectedMember.assigneeIn]
                                }
                           }
                         
                            assigneeTasks = [];
                        }

                        if (this.state.assignedMembers.reviewer && this.state.assignedMembers.reviewer === m.id) {
                            reviewerTasks = [...reviewerTasks, ...workstreams.selectedMember.reviewerIn];
                            reviewer = {
                                users: {
                                    new: m.id,
                                    old: workstreams.selectedMember.id
                                },
                                taskIds: [...workstreams.selectedMember.reviewerIn]
                            }

                        } else if((this.state.assignedMembers.reviewer === null && m.id === workstreams.selectedMember.id) || (this.state.assignedMembers.reviewer !== 0 && this.state.assignedMembers.reviewer !== workstreams.selectedMember.id && m.id === workstreams.selectedMember.id)) {
                            if(this.state.assignedMembers.reviewer === null){
                                reviewer = {
                                    users: {
                                        new: null,
                                        old: workstreams.selectedMember.id
                                    },
                                    taskIds: [...workstreams.selectedMember.reviewerIn]
                                }
                            }
                          
                            reviewerTasks = [];
                        }

                        if (this.state.assignedMembers.approver && this.state.assignedMembers.approver === m.id) {
                            approverTasks = [...approverTasks, ...workstreams.selectedMember.approverIn];
                            approver = {
                                users: {
                                    new: m.id,
                                    old: workstreams.selectedMember.id
                                },
                                taskIds: [...workstreams.selectedMember.approverIn]
                            }
                        } else if((this.state.assignedMembers.approver === null && m.id === workstreams.selectedMember.id) || (this.state.assignedMembers.approver !== 0 && this.state.assignedMembers.approver !== workstreams.selectedMember.id && m.id === workstreams.selectedMember.id)) {
                           if(this.state.assignedMembers.approver === null){
                            approver = {
                                users: {
                                    new: null,
                                    old: workstreams.selectedMember.id
                                },
                                taskIds: [...workstreams.selectedMember.approverIn]
                            }
                           }
                          
                            approverTasks = [];
                        }

                        return currentMemmber;
                    }),
                    toUpdate: reassignedValidation(toUpdate,{assignee, approver, reviewer}),
                }
            });
        
            handleClose();
        }

        const reassignedValidation =(toUpdate,{assignee, approver, reviewer})=>{     
           let result = toUpdate.map(obj=>{
                if(Object.keys(assignee).length){
                    if(JSON.stringify(assignee.taskIds) === JSON.stringify(obj.assignee.taskIds) && assignee.users.old === obj.assignee.users.new){
                        assignee = {}
                        return {...obj,assignee:{}}
                    }
                }
                if(Object.keys(approver).length){
                    if(JSON.stringify(approver.taskIds) === JSON.stringify(obj.approver.taskIds) && approver.users.old === obj.approver.users.new){
                        reviewer = {}
                        return {...obj,approver:{}}
                    }
                }
                if(Object.keys(reviewer).length){
                    if(JSON.stringify(reviewer.taskIds) === JSON.stringify(obj.reviewer.taskIds) && reviewer.users.old === obj.reviewer.users.new){
                        approver = {}
                        return {...obj,reviewer:{}}
                    }
                }   
                return {...obj}
            
            })
            
            return [...result, ...[{assignee,approver,reviewer}]]
        }
        
        return (
            <div class="modal fade reassignTask-modal bg-overlay" data-backdrop="static" data-keyboard="false" id="reassignTask">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bb pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 brndnTxt-m mb0 mt5">Re-assign {workstreams.selectedMember.fullName}'s Task/s</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body pt10 pb10">
                            {workstreams.selectedMember.assigneeIn?.length > 0 && (
                                <div class="reassignTaskContainer">
                                    <div class="taskCountLabel mr20">
                                        <a onClick={() => handlePrefilters("assignee")}>
                                            <span class="text-blue text-underlined">{workstreams.selectedMember.assigneeIn?.length} task/s</span>
                                        </a>
                                        <span> as Assignee:</span>
                                    </div>
                                    <i class="material-icons searchIcon">search</i>
                                    <Search onChange={handleChangeAssignee} projectId={this.props.projectId} isClose={this.state.isClose} avatarBaseUrl={`/api/file/profile_pictures/`} />
                                </div>
                            )}
                            {workstreams.selectedMember.reviewerIn?.length > 0 && (
                                <div class="reassignTaskContainer">
                                    <div class="taskCountLabel mr20">
                                        <a onClick={() => handlePrefilters("reviewer")}>
                                            <span class="text-blue text-underlined">{workstreams.selectedMember.reviewerIn?.length} task/s</span>
                                        </a>
                                        <span> as Reviewer:</span>
                                    </div>
                                    <i class="material-icons searchIcon">search</i>
                                    <Search onChange={handleChangeReviewer} projectId={this.props.projectId} isClose={this.state.isClose} avatarBaseUrl={`/api/file/profile_pictures/`} />
                                </div>
                            )}
                            {workstreams.selectedMember.approverIn?.length  > 0 && (
                                <div class="reassignTaskContainer">
                                    <div class="taskCountLabel mr20">
                                        <a onClick={() => handlePrefilters("approver")}>
                                            <span class="text-blue text-underlined">{workstreams.selectedMember.approverIn?.length } task/s</span>
                                        </a>
                                        <span> as Approver:</span>
                                    </div>
                                    <i class="material-icons searchIcon">search</i>
                                    <Search onChange={handleChangeApprover} projectId={this.props.projectId} isClose={this.state.isClose} avatarBaseUrl={`/api/file/profile_pictures/`} />
                                </div>
                            )}
                        </div>
                        <div class="modal-footer bt">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4 text-left">
                                    <button type="button" class="btn btnCancel ml0" data-dismiss="modal" onClick={handleClose}>Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class={`btn btnSave`} onClick={handleSave}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReassignTask;
